/**
 * "Maximum price for alerts" (#357): a premium user's cap for one tracked
 * product. Empty means any price. The API refuses anything outside $1-$99,999.99
 * (a $0 cap would silence every alert), and so does this, before a request is made.
 */
export const MAX_ALERT_PRICE_FLOOR = 1;
export const MAX_ALERT_PRICE_CEILING = 99999.99;

export function parseMaxAlertPrice(rawInput) {
    const text = String(rawInput ?? '').replace(/[$,\s]/g, '');
    if (text === '') {
        return { value: null, error: '' };
    }
    if (!/^\d+(\.\d{1,2})?$/.test(text)) {
        return { value: null, error: 'Enter a price like 2999 or 2999.99' };
    }
    const value = Number(text);
    if (value < MAX_ALERT_PRICE_FLOOR || value > MAX_ALERT_PRICE_CEILING) {
        return { value: null, error: 'Enter a price between $1 and $99,999.99' };
    }
    return { value, error: '' };
}

export function formatMaxAlertPrice(value) {
    if (value === null || value === undefined || value === '') {
        return '';
    }
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
        return '';
    }
    return amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

export function describeMaxAlertPrice(value) {
    const formatted = formatMaxAlertPrice(value);
    return formatted
        ? `You'll only be emailed when it's ${formatted} or less.`
        : "You'll be emailed at any price.";
}

/** Has the box been changed from what is saved? "3000" and a saved 3000.00 are the same. */
export function isMaxAlertPriceDirty(rawInput, savedValue) {
    const parsed = parseMaxAlertPrice(rawInput);
    if (parsed.error) {
        return true;
    }
    const saved = savedValue === null || savedValue === undefined || savedValue === '' ? null : Number(savedValue);
    return parsed.value !== saved;
}
